import Event from '../../core/Event';
import EstimationPeriod from '../../../domain/EstimationPeriod';

export default class EstimationPeriodGetSucceed extends Event {
    public static type = 'EstimationPeriodGetSucceed';

    constructor(public readonly estimationPeriod: EstimationPeriod) {
        super(EstimationPeriodGetSucceed.type);
    }
}



// WEBPACK FOOTER //
// ./src/application/admin/events/EstimationPeriodGetSucceed.ts